import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { StatusService } from './status.service';

@Component({
  selector: 'shared-status',
  standalone: true,
  imports: [NgClass],
  templateUrl: './status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusComponent<T> {
  private statusService = inject(StatusService<T>);

  statusValue = input.required<T>();
  statusMessage = input.required<string>();

  protected getColor(status: keyof T): string {
    return this.statusService.getColor(status);
  }
}
